import React from 'react'

export const FullScreenExitIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter
        id="shadow"
        x="-20%"
        y="-20%"
        width="140%"
        height="140%"
      >
        <feDropShadow
          dx="0"
          dy="0"
          stdDeviation="1.5"
          floodColor="rgba(0,0,0,0.6)"
        />
      </filter>
    </defs>

    <g filter="url(#shadow)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.75 7.02907C0.75 3.56124 3.56124 0.75 7.02907 0.75H16.9709C20.4388 0.75 23.25 3.56124 23.25 7.02907V16.9709C23.25 20.4388 20.4388 23.25 16.9709 23.25H7.02907C3.56124 23.25 0.75 20.4388 0.75 16.9709V7.02907ZM9.75 7C9.75 8.51878 8.51878 9.75 7 9.75H4C3.58579 9.75 3.25 9.41421 3.25 9C3.25 8.58579 3.58579 8.25 4 8.25H7C7.69036 8.25 8.25 7.69036 8.25 7V4C8.25 3.58579 8.58579 3.25 9 3.25C9.41421 3.25 9.75 3.58579 9.75 4V7ZM14.25 7C14.25 8.51878 15.4812 9.75 17 9.75H20C20.4142 9.75 20.75 9.41421 20.75 9C20.75 8.58579 20.4142 8.25 20 8.25L17 8.25C16.3096 8.25 15.75 7.69036 15.75 7V4C15.75 3.58579 15.4142 3.25 15 3.25C14.5858 3.25 14.25 3.58579 14.25 4V7ZM14.25 17C14.25 15.4812 15.4812 14.25 17 14.25L20 14.25C20.4142 14.25 20.75 14.5858 20.75 15C20.75 15.4142 20.4142 15.75 20 15.75L17 15.75C16.3096 15.75 15.75 16.3096 15.75 17L15.75 20C15.75 20.4142 15.4142 20.75 15 20.75C14.5858 20.75 14.25 20.4142 14.25 20L14.25 17ZM7 14.25C8.51878 14.25 9.75 15.4812 9.75 17L9.75 20C9.75 20.4142 9.41421 20.75 9 20.75C8.58579 20.75 8.25 20.4142 8.25 20V17C8.25 16.3096 7.69036 15.75 7 15.75L4 15.75C3.58579 15.75 3.25 15.4142 3.25 15C3.25 14.5858 3.58579 14.25 4 14.25L7 14.25Z"
        fill="white"
      />
    </g>
  </svg>
)
